<script>
export default {
	name: 'Delete',
	props: {
		text: {
			type: String,
			required: true,
		},
		textUnder: {
			type: String,
			required: true,
		},
	},
};
</script>
<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-12 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					class="w-16 h-16"
					alt="Luca Education"
					src="@/assets/images/illustrations/warning.png"
					title="Luca Education"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				{{ text }}
			</div>
			<div class="text-center text-neutral-500 mt-4">
				{{ textUnder }}
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('close')"
			>
				Huỷ
			</button>
			<button
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="$emit('submit')"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>
